import React from 'react';
import AuthErrorBoundary from '../components/auth/AuthErrorBoundary';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import { UserFactsContainer } from '../components/userFacts/UserFactsContainer';

const UserFactsPage: React.FC = () => {
  return (
    <ProtectedRoute>
      <AuthErrorBoundary>
        <UserFactsContainer />
      </AuthErrorBoundary>
    </ProtectedRoute>
  );
};

export default UserFactsPage;
